import Page from "../../../layout/Page/Page";
import PageWrapper from "../../../layout/PageWrapper/PageWrapper";

import { CommonWorkResourceEmployeeList } from "./Common/CommonWorkResourceEmployeeList";


const WorkResourceEmployeePage = () => {

	return (
		<PageWrapper title='Ferramentas e EPI do colaborador'>
			<Page container='fluid'>
				<div className='row h-100'>
					<div className='col-12'>
						<CommonWorkResourceEmployeeList />
					</div>
				</div>
			</Page>
		</PageWrapper>
	);
};

export default WorkResourceEmployeePage;